export class WFToggleReimbursableParametersDto {
    lineItemWorkflowId: number;
    communityId: number;
}
